import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Vista completa de calificación", -1)
const _hoisted_2 = { class: "d-flex pt-2 pb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)

import Modal from "@/components/Modal.vue";
import { ref, watch } from "vue";
import { getTh } from "@/util/data";
import { AppModule } from "@/store/modules/app";

import { IColumn } from "@/types/components";
import { omniChannelClient } from "@/conection";
import { IConfig } from "@/types/store";
import { AuthModule } from "@/store/modules/Auth";

// => Data

export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: [Boolean, null] },
    agent_group: null,
    column: null
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", { show }: { show: boolean }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	show: boolean | undefined;
	agent_group: string | undefined | null;
	column: IColumn | undefined;
}

const loading = ref(false);
const THeader = ref<IColumn[] | undefined>(undefined);

// props


// emits


// => Computeds
watch(
	() => props.show,
	newValue => {
		if (newValue) {
			initModal();
		}
	}
);
//=>Methods
function closeModal() {
	emits("changeModal", { show: false });
}

async function initModal() {
	try {
		loading.value = true;

		const userConfig = AppModule.configs.find(c => c.name === "dynamic_user");
		let dynamicConfig = undefined;
		if (props.column?.agent_group) {
			const response = await omniChannelClient.get<IConfig>(
				`/organization/ba/config_typification_dynamic_by_agentGroup/${AuthModule.organizationID}`,
				{
					params: {
						agentGroup: props.column?.agent_group,
					},
				}
			);
			dynamicConfig = response.data;
		} else {
			dynamicConfig = AppModule.configs.find(
				c => c.name === "dynamic_typification"
			);
		}
		THeader.value = await getTh(userConfig, dynamicConfig);
		loading.value = false;
	} catch (error) {
		console.error("Error:// ", error);
		loading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.show,
    "show-close": true,
    "modal-classes": "modal-dada",
    "body-classes": "py-0",
    "validate-on-mount": true,
    style: {"animation-duration":"0.3s"},
    size: "xl",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        "max-height": "70vh",
        "view-class": "w-100",
        "wrap-class": "w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_skeleton, {
            loading: loading.value,
            rows: 5,
            animated: ""
          }, null, 8, ["loading"]),
          (!loading.value)
            ? (_openBlock(), _createBlock(_component_el_descriptions, {
                key: 0,
                direction: "vertical",
                column: 3,
                border: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(THeader.value, (header, index) => {
                    return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: index,
                      label: header.text
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.column && (props.column as any)[header.value.toString()]
							?  (props.column as any)[header.value.toString()]
							: "No disponible"), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_button, {
          type: "warning",
          size: "sm",
          loading: loading.value,
          onClick: closeModal
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})